import axios from "axios";
import { Base_URL } from "../url";

// Get all countries
export const getAllCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

// Get regions by country
export const getRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(`${Base_URL}/RegionMaster/GetRegionsByCountry`, {
      countryCode: countryCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

// Get districts by region
export const getDistrictsByRegion = async (regionCode) => {
  try {
    const response = await axios.post(`${Base_URL}/DistrictMaster/GetDistrictsByRegion`, {
      regionCode: regionCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};

// Get tehsils by district
export const getTehsilsByDistrict = async (districtCode) => {
  try {
    const response = await axios.post(`${Base_URL}/TehsilMaster/GetTehsilsByDistrict`, {
      districtCode: districtCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tehsils!";
  }
};

// Create new city
export const createCity = async (cityData, userName = "11") => {
  try {
    const response = await axios.post(
      `${Base_URL}/CityMaster/CreateCity?UserName=${userName}`,
      cityData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating city!";
  }
};